import { SHStack } from "@components/design-systems";
import { FeeDetailDTO } from "@models/platform-analysis/entities/steps/fee";
import { FeeHeatmapMode } from "@models/platform-analysis/enums/fee/heatmapMode";
import { useTheme } from "@mui/material";
import { PDFFeeAnalysisConfig } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/fee-analysis/configs";

type FamilyLevelVerticalDashLineProps = {
  numOfItems: number;
  type?: FeeHeatmapMode;
  firstProductFeeDetails?: FeeDetailDTO[];
  isFamilyLevel?: boolean;
};

export const VerticalDashLineV2 = ({
  numOfItems,
  type = FeeHeatmapMode.Detail,
  firstProductFeeDetails,
  isFamilyLevel = false,
}: FamilyLevelVerticalDashLineProps) => {
  const { palette } = useTheme();

  const hasManyColumns =
    firstProductFeeDetails &&
    firstProductFeeDetails.length >
      PDFFeeAnalysisConfig.MaxFeeDetailsColumnToDisplayLogo;

  if (type === FeeHeatmapMode.Projection) {
    return (
      <SHStack
        direction={"row"}
        justifyContent={"space-between"}
        paddingLeft={"6px"}
      >
        {Array.from({ length: numOfItems }).map((_, i) => {
          const isFirstItem = i === 0;
          const isLastItem = i === numOfItems - 1;
          return (
            <SHStack
              key={i}
              height={5}
              width={"100%"}
              justifyItems={"end"}
              direction={"row"}
              alignItems={"start"}
              justifyContent={isLastItem ? "space-between" : "flex-start"}
            >
              <SHStack
                width={"1px"}
                bgcolor={palette.text.primary}
                height={"100%"}
                marginLeft={isFirstItem ? "2px" : 0}
              />
              {isLastItem && (
                <SHStack
                  width={"1px"}
                  bgcolor={palette.text.primary}
                  height={"100%"}
                />
              )}
            </SHStack>
          );
        })}
      </SHStack>
    );
  }

  return (
    <SHStack direction={"row"} flex={1} paddingLeft={"6px"}>
      {firstProductFeeDetails?.map((feeDetail, index) => (
        <SHStack
          key={index}
          flex={1}
          justifyContent={
            index === firstProductFeeDetails.length - 1
              ? "justify-between"
              : "flex-start"
          }
          alignItems={"center"}
          flexDirection={"row"}
          sx={{
            maxWidth: hasManyColumns && feeDetail.isPysRefund ? "50px" : "100%",
            mr: index === 0 ? "15px" : "1.5px",
            ml:
              index === firstProductFeeDetails.length - 1
                ? isFamilyLevel
                  ? "25px"
                  : "15px"
                : "1.5px",
            transform: index === 0 ? "translateX(1.5px)" : undefined,
          }}
        >
          {index !== firstProductFeeDetails.length - 1 && (
            <SHStack
              width={"1px"}
              bgcolor={palette.text.primary}
              height={"5px"}
              marginLeft={
                index === 0
                  ? "-2px"
                  : index === 1
                  ? "-10px"
                  : index === firstProductFeeDetails.length - 1
                  ? "-13px"
                  : "-2px"
              }
            />
          )}
          {index === firstProductFeeDetails.length - 1 && (
            <SHStack
              direction={"row"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <SHStack
                width={"1px"}
                bgcolor={palette.text.primary}
                height={"5px"}
                marginLeft={"-13px"}
              />
              <SHStack
                width={"1px"}
                bgcolor={palette.text.primary}
                height={"5px"}
                marginRight={"-2px"}
                sx={{ transform: "translateX(-1.5px)" }}
              />
            </SHStack>
          )}
        </SHStack>
      ))}
    </SHStack>
  );
};
